var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemandLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "current",
    strokeWidth: 0,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M4.5139 13.6389C4.70372 13.6389 4.86691 13.5706 5.00348 13.434C5.14005 13.2975 5.20833 13.1343 5.20833 12.9444C5.20833 12.7546 5.14005 12.5914 5.00348 12.4549C4.86691 12.3183 4.70372 12.25 4.5139 12.25C4.32408 12.25 4.16088 12.3183 4.02431 12.4549C3.88774 12.5914 3.81946 12.7546 3.81946 12.9444C3.81946 13.1343 3.88774 13.2975 4.02431 13.434C4.16088 13.5706 4.32408 13.6389 4.5139 13.6389ZM3.81946 10.1667H5.20833V5.29167H3.81946V10.1667ZM8.25002 13.7083H14.0695V12.3195H8.25002V13.7083ZM8.25002 10.1667H14.0695V8.77777H8.25002V10.1667ZM8.25002 6.68054H14.0695V5.29167H8.25002V6.68054ZM1.8889 17C1.5139 17 1.18867 16.8623 0.913208 16.5868C0.637736 16.3114 0.5 15.9861 0.5 15.6111V3.38888C0.5 3.01388 0.637736 2.68865 0.913208 2.41319C1.18867 2.13773 1.5139 2 1.8889 2H16C16.375 2 16.7003 2.13773 16.9757 2.41319C17.2512 2.68865 17.3889 3.01388 17.3889 3.38888V15.6111C17.3889 15.9861 17.2512 16.3114 16.9757 16.5868C16.7003 16.8623 16.375 17 16 17H1.8889ZM1.8889 15.6111H16V3.38888H1.8889V15.6111Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandLetter);
export default __webpack_public_path__ + "static/media/DemandLetter.466c4b24fbe5d96bad7c1b68e8821b09.svg";
export { ForwardRef as ReactComponent };